import { ROLES_PREMISSAS_VISUALIZACAO } from "./departamentosOrcamento";

// Premissas · Equipamentos e Materiais: leitura ampla (ROLES_PREMISSAS_VISUALIZACAO); edição só
// admin (já implementado via isAdmin em components/gestaoOrcamentaria/PremissasEquipamentosView.js).
// Espelha backend/config.py ROLES_PREMISSAS_EQUIPAMENTOS — mantenha em sincronia.
export const ROLES_PREMISSAS_EQUIPAMENTOS = ROLES_PREMISSAS_VISUALIZACAO;
